import { XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "../Button";
import { useSelectContext } from "./SelectContext";

/** The `clearable` button `Select.Trigger` renders beside the field; hidden while nothing is selected. */
export const SelectClear = () => {
  const { t } = useTranslation();
  const { selectedValues, clearable, clear, disabled } = useSelectContext();
  if (!clearable || selectedValues.length === 0) return null;

  return (
    <Button
      data-slot="select-clear"
      variant="ghost"
      color="muted"
      size="sm"
      iconOnly
      aria-label={t("Clear selection")}
      disabled={disabled}
      onClick={clear}
    >
      <XIcon />
    </Button>
  );
};
